const $inject = ['$scope','$routeParams', 'dataService', 'settingsService'];

const lbaMultiSelectCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.items = settingsService.options[vm.settings.optionsAt];
  vm.validationPattern = vm.settings.validationRegex;
  vm.isValid = true;

  function validateData(data) {
    if (vm.validationPattern) {
      if (data && data.length) {
        let regex = new RegExp(vm.validationPattern);
        vm.isValid = data.every(item => item && regex.test(item));
      } else {
        vm.isValid = true;
      }
      $scope.$emit('ValidationStatusChanged', {
        controllerName: vm.settings.dataAt,
        value: data,
        isValid: vm.isValid
      });
    }
  }

  // Run initial validation on load
  if (vm.validationPattern && vm.data) {
    validateData(vm.data);
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      if (vm.settings.transformUppercase && newData && newData.length) {
        let transformed = newData.map(item => item ? item.toUpperCase() : item);
        if (!_.isEqual(transformed, newData)) {
          vm.data = transformed;
          newData = transformed;
        }
      }

      _.set(dataService.data.activeItem, dataLookUp, newData);

      validateData(newData);
    }
  });

};

lbaMultiSelectCtrl.$inject = $inject;

export default lbaMultiSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaMultiSelect/lbaMultiSelectCtrl.js